import './vpm/index';
import './helpers';
import './breakpoint-controller';
import './grunticon-controller';
import './scroll-controller';



// WEBPACK FOOTER //
// ./wp-content/themes/synergy/assets/scripts/source/main.js